<template>
  <div class="">
    <agency-contacts-edit> </agency-contacts-edit>
  </div>
</template>

<script>
import AgencyContactsEdit from "@/components/accounting/accounting-agency/agency-contacts/edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
    ...mapActions("breadcrumbs", { removeBCS: "remove" }),
    ...mapGetters("breadcrumbs", { loadBCS: "loadBreadcrumbs" }),
  },
  components: {
    AgencyContactsEdit,
  },
  beforeMount() {
    let bcs = this.loadBCS();
    if (this.$route.query.fromShortcut) {
      bcs.push({
        text: "Modifica Anagrafica",
        path: "agency_contacts.edit",
        level: 3,
      });
      bcs.forEach((element) => {
        this.notifyQueue({
          text: element.text,
          path: element.path,
          tab: element.tab,
          level: element.level,
          disabled: element.disabled,
        });
      });
      // this.$router.replace({ query: null });
    } else {
      this.notifyQueue({
        text: "Modifica Anagrafica",
        path: "agency_contacts.edit",
        level: 4,
      });
    }
  },
};
</script>
